import { useRefGetter } from '../../use';
import { useCallback, useEffect, useRef } from 'react';
import { addMutationHandler, getDefaultElementPosition, getElementPosition, isClient, isElementPositionEqual, removeMutationHandler } from '../../co-dom';
import { useContainer } from './useContainer';
export function useElementPosition(element, enable, onChange, options) {
  var positionRef = useRef(getDefaultElementPosition());
  var elemGetter = useContainer(element);
  var enableGetter = useRefGetter(enable);
  var onChangeGetter = useRefGetter(onChange);
  var update = useCallback(function (force) {
    var elem = elemGetter();

    if (!force && !enableGetter()() || elem == null) {
      return;
    }

    var currentPosition = getElementPosition(elem);

    if (!isElementPositionEqual(positionRef.current, currentPosition)) {
      positionRef.current = currentPosition;
      onChangeGetter()(currentPosition);
    }
  }, []);
  useEffect(function () {
    if (!enableGetter()() || options.disabledCaptureElementUpdate) {
      return;
    }

    update();
  });
  useEffect(function () {
    update(true);

    if (isClient()) {
      addMutationHandler(update, {
        mutation: !options.disabledCaptureElementSizeChange,
        transition: !options.disabledCaptureTransition,
        animation: !options.disabledCaptureAnimation,
        scroll: !options.disabledCaptureContainerScroll || !options.disabledCaptureStickyCheck,
        resize: !options.disabledCaptureWindowSize
      });
      return function () {
        positionRef.current = getDefaultElementPosition();
        removeMutationHandler(update);
      };
    }
  }, []);
  return positionRef.current;
}